import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { ApiResponse } from '../_model/ApiResponse';
import { Request } from '../_model/procurement/Request';
import { Expense, Account } from '../_model/procurement/Expense';
import { ProcurementGroupResponse } from '../_model/procurement/ProcurementGroup';
import { ProcurementItemRequest, ProcurementItemResponse } from '../_model/procurement/ProcurementItem';
import { VendorResponse } from '../_model/procurement/Vendor';
import { PoItemAuthorityDto, PoItemAuthoritySaveRequest, PoItemAuthoritiesResponse } from '../_model/procurement/PoItemAuthority';

@Injectable({
  providedIn: 'root'
})
export class ProcurementService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  // Procurement Groups
  getProcurementGroups(): Observable<ProcurementGroupResponse> {
    return this.get<ProcurementGroupResponse>('/api/v1/po/list');
  }
  
  // Procurement Items
  getProcurementItems(request: ProcurementItemRequest): Observable<ProcurementItemResponse> {
    return this.post<ProcurementItemResponse>('/api/v1/po/items', request);
  }

  // Vendors - Satıcı listesi (3 harf yazınca arama)
  getVendors(searchTerm: string): Observable<VendorResponse> {
    return this.post<VendorResponse>('/api/v1/po/vendors', { searchTerm });
  }

  // Save Procurement (Talep/Masraf)
  saveProcurement(request: Request): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po', request);
  }

  // Validate Request Header (AI değerlendirmesi)
  validateRequestHeader(request: Request): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/request-header/validate', request);
  }

  // Onay Bekleyenler - Waiting for Approvals
  getWaitingForApprovals(searchRequest?: any): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/waitingforapprovals', searchRequest || {});
  }

  // Taleplerim - My Requests
  getMyRequests(searchRequest?: any): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/myrequests', searchRequest || {});
  }

  // Onaylananlar - Approved
  getApproveds(searchRequest?: any): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/approveds', searchRequest || {});
  }

  // Reddedilenler - Rejected
  getRejecteds(searchRequest?: any): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/rejecteds', searchRequest || {});
  }

  // Tüm Kayıtlar - All Records
  getAllRequests(searchRequest?: any): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/all', searchRequest || {});
  }

  // Delete Procurement Request
  deleteRequest(id: number): Observable<ApiResponse> {
    return this.delete<ApiResponse>(`/api/v1/po/${id}`);
  }

  // Get Procurement Detail by ID
  getRequestDetail(id: number): Observable<ApiResponse> {
    return this.post<ApiResponse>(`/api/v1/po/detail/${id}`, {});
  }

  // Approve Procurement Request (Absence ile aynı workflow endpoint'i)
  approveRequest(request: any): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/wf/approvals', request);
  }

  // Reject Procurement Request (Procurement modülü reject endpoint'i)
  rejectRequest(request: any): Observable<ApiResponse> {
    return this.put<ApiResponse>('/api/v1/po/reject', request);
  }

  // Kalem yetkileri - Çalışanın mevcut yetkilerini getir
  getPoItemAuthorities(employeeId: number): Observable<PoItemAuthoritiesResponse> {
    return this.get<PoItemAuthoritiesResponse>(`/api/v1/po/item-authorizations/${employeeId}`);
  }

  // Kalem yetkileri - Çalışanın yetkilerini kaydet
  savePoItemAuthorities(request: PoItemAuthoritySaveRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/item-authorizations', request);
  }

  // ERP Tedarikçi - ERP'den tedarikçi bilgilerini çek
  getErpVendors(): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/getErpVendors', {});
  }

  // ERP Tedarikçi - Yeni tedarikçileri portale aktar
  addNewErpVendors(): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/addNewErpVendors', {});
  }

  // ERP Kalem - ERP'den kalem bilgilerini çek
  getErpItems(): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/getErpItems', {});
  }

  // ERP Kalem - Yeni kalemleri portale aktar
  addNewErpItems(): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/po/addNewErpItems', {});
  }
}
